import { useAuth } from '../useAuth/useAuth'

import { getPartnerFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

export const usePublicFundraiserConfig = () => {
  const { state } = useAuth()
  const partner = getPartnerFromAuthState(state)

  return {
    publicFundraiserEnabled: partner?.publicFundraiser?.enabled ?? false
  }
}
